import React from "react";

export default function UserLockersHistoryComponent({locker}) {
  console.log("histroy lockre data :", locker);
  return (
    <div className="locker-card">
      <div className="top">
        <div className="title">Penn Station Luggage Hub</div>
        <div className="status">Completed</div>
      </div>

      <div className="sub-text">Small locker</div>

      <div className="date">2026-02-15 - 2026-02-15</div>

      <hr />

      <div className="total">Total: $12</div>
    </div>
  );
}